import { toast } from 'sonner';
import { Siren } from 'lucide-react';
import { curPos } from '../lib/trackRec';
import { olcEncode } from '../lib/olc';

const getPos = () => new Promise((res) => {
  const c = curPos();
  if (c) return res(c);
  if (!navigator.geolocation) return res(null);
  navigator.geolocation.getCurrentPosition((p) => res({ lat: p.coords.latitude, lon: p.coords.longitude, acc: p.coords.accuracy, alt: p.coords.altitude }), () => res(null), { enableHighAccuracy: true, timeout: 10000, maximumAge: 30000 });
});

// emergency: share own position (coords, plus code, map link) via share sheet / clipboard
export default function SosButton({ t }) {
  const go = async () => {
    const p = await getPos();
    if (!p) return toast.error(t.sosNoGps);
    const txt = `🆘 ${t.sosText}: ${p.lat.toFixed(6)}, ${p.lon.toFixed(6)}${p.acc ? ` (±${Math.round(p.acc)} m)` : ''}${p.alt != null ? ` · ${Math.round(p.alt)} m` : ''} · ${olcEncode(p.lat, p.lon)} · https://maps.google.com/?q=${p.lat.toFixed(6)},${p.lon.toFixed(6)} · ${new Date().toLocaleTimeString()}`;
    if (navigator.share) { try { await navigator.share({ text: txt }); return; } catch (e) { if (e?.name === 'AbortError') return; } }
    try { await navigator.clipboard.writeText(txt); toast.success(t.sosCopied, { duration: 8000 }); } catch { toast.message(txt, { duration: 20000 }); }
  };
  return <button type="button" className="btn btn-red btn-sm sos-btn" data-testid="sos-share-btn" onClick={go}><Siren size={14} /> {t.sosBtn}</button>;
}
